import { createAction, props } from '@ngrx/store';
import { ContactItem } from './service.interface';

export const contactSendMessageAction = createAction('service:CONTACT_SEND_MESSAGE', props<{ message: ContactItem }>());
export const contactSendMessageSuccessAction = createAction('service:CONTACT_SEND_MESSAGE_SUCCESS');
export const contactSendMessageFailAction = createAction('service:CONTACT_SEND_MESSAGE_FAIL', props<{ payload }>());

// @ts-ignore
contactSendMessageAction.logPayload = true;
// @ts-ignore
contactSendMessageFailAction.logPayload = true;
